/* tslint:disable:max-line-length */
import React from 'react';
import { IconTypeProps } from '../types';
import classNames from 'classnames';

export const PlusIcon = ({
  className,
  style,
  color = '#938BB7',
  onClick,
}: IconTypeProps) => {
  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M10.9463 4.16984L8.00002 7.11612L5.05374 4.16984C4.97235 4.08845 4.84051 4.08845 4.75912 4.16984L4.16986 4.75909C4.08847 4.84048 4.08847 4.97233 4.16986 5.05372L7.11614 8L4.16986 10.9463C4.08847 11.0277 4.08847 11.1595 4.16986 11.2409L4.75912 11.8302C4.84051 11.9116 4.97235 11.9116 5.05374 11.8302L8.00002 8.88388L10.9463 11.8302C11.0277 11.9116 11.1595 11.9116 11.2409 11.8302L11.8302 11.2409C11.9116 11.1595 11.9116 11.0277 11.8302 10.9463L8.88391 8L11.8302 5.05372C11.9116 4.97233 11.9116 4.84048 11.8302 4.75909L11.2409 4.16984C11.1595 4.08845 11.0277 4.08845 10.9463 4.16984Z"
        fill={color}
      />
    </svg>
  );
};
